import React, { useCallback, useMemo } from 'react';
import { Box, IconButton, PinIcon } from '@cdl/heartbeat-react';
import { useDispatch, useSelector } from 'react-redux';
import { ClusterBeat } from '../../clustering.types';
import { togglePinnedBeat } from '../../thunks/toggle-pinned-beat.thunk';
import {
  isBeatHoveredSelector,
  pinnedIdSelector,
} from '../../../beats/beats.selector';

interface Props {
  beat: ClusterBeat;
}

export const PinBeat: React.FC<Props> = ({ beat }) => {
  const dispatch = useDispatch();
  const hovered = useSelector(isBeatHoveredSelector(beat.id));
  const pinnedId = useSelector(pinnedIdSelector);
  const isPinned = useMemo(() => pinnedId === beat.id, [pinnedId, beat.id]);
  const toggleBeat = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.stopPropagation();
      dispatch(togglePinnedBeat(beat.id));
    },
    [dispatch, beat.id],
  );
  return (
    <Box display='flex' justifyContent='center'>
      {(hovered || pinnedId === beat.id) && (
        <IconButton
          variant='tertiary'
          size='sm'
          onClick={toggleBeat}
          aria-label='Pin beat'
          isActive={isPinned}
          icon={<PinIcon />}
        />
      )}
    </Box>
  );
};
